import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
import config from '../../../../config';
import api from '../../../../services/api/service';
import ActionBar from '../../components/ActionBar';
import Fieldset from '../Fieldset';
import Input from '../Input';
import Select from '../Select';
import Textarea from '../Textarea';
import InlineGroup from '../InlineGroup';
import {Content} from './styles';

function DeliveryInfo({t, data, setData, errors, availDeliveryDays, loading, setLoading, setAvailDeliveryDays}) {
  const [nextDisabled, disableNext] = useState(true);
  const [deliveryMessage, setDeliveryMessage] = useState();
  
  const availContactPeriods = config.availableContactPeriods;
  const availDeliveryPeriods = config.availableDeliveryPeriods;

  useEffect(() => {
    disableNext(!(data.companyName && data.deliveryAddress && data.deliveryCity && data.deliveryZipCode));
  });

  useEffect(() => {
    if (data.deliveryZipCode.length >= 4) {
      if (availDeliveryDays.length > 0) {
        setDeliveryMessage('choose');
      } else {
        setDeliveryMessage('noOptions');
      }
    } else {
      setDeliveryMessage('invalid');
    }
  }, [data.deliveryZipCode, availDeliveryDays]);

  function handleNext() {
    return true;
  }

  function handleChange({target: {name, value}}) {
    setData({[name]: value});
  }

  async function handleDeliveryZipCodeChange({target: {name, value}}) {
    setData({[name]: value});

    if (value.length >= 4) {
      setLoading(true);

      const respTown = await api.getZipCodeInfo(value);
      const respDeliveryDays = await api.getDeliveryDays(value);

      if (!respTown.error) {
        setData({deliveryCity: respTown.townName});
      }
      
      setAvailDeliveryDays(respDeliveryDays);
      if (respDeliveryDays.length > 0) {
        setData({deliveryDay: respDeliveryDays[0]})
      }

      setLoading(false);
    }
  }

  function handleCheck() {
    let newData = {
      diffAddrForMail: !data.diffAddrForMail
    };

    setData(newData);
  }
  
  return (
    <div>
      <Content>
        <Fieldset legend={t('form.legends.deliveryInfo')}>
          <p>
            {t('prefilledData')}
          </p>

          <Input
            id="deliveryAddress"
            type="text"
            value={data.deliveryAddress}
            error={errors.deliveryAddress}
            onChange={handleChange}
            disabled={loading}
          />

          <Input
            id="deliveryZipCode"
            type="text"
            value={data.deliveryZipCode}
            error={errors.deliveryZipCode}
            onChange={handleDeliveryZipCodeChange}
            disabled={loading}
          />

          <Input
            id="deliveryCity"
            type="text"
            value={data.deliveryCity}
            error={errors.deliveryCity}
            onChange={handleChange}
            disabled={loading}
          />

        </Fieldset>

        <Fieldset legend={t('form.legends.deliveryDate')}>
          <p>{t('form.deliveryDay.messages.' + deliveryMessage, {brand: config.brand})}</p>

          <Select
            id="deliveryDay"
            value={data.deliveryDay}
            error={errors.deliveryDay}
            onChange={handleChange}
            options={availDeliveryDays.map(day => ({label: day.label, value: day.value}))}
            disabled={loading}
          />

          <div className="row mb-4">
            <div className="col">
              <Select
                id="preferredContactPeriod"
                value={data.preferredContactPeriod}
                error={errors.preferredContactPeriod}
                onChange={handleChange}
                options={availContactPeriods.map(period => ({label: period, value: period}))}
                disabled={loading}
              />
            </div>
            <div className="col">
              <Select
                id="deliveryPeriod"
                value={data.deliveryPeriod}
                error={errors.deliveryPeriod}
                onChange={handleChange}
                options={availDeliveryPeriods.map(period => ({label: period, value: period}))}
                disabled={loading}
              />
            </div>
          </div>

        </Fieldset>

        <Fieldset legend={t('form.legends.otherComments')}>

          <Textarea
            id="deliveryNotes"
            type="number"
            value={data.deliveryNotes}
            error={errors.deliveryNotes}
            placeholder={t('form.deliveryNotes.info')}
            onChange={handleChange}
          />
        </Fieldset>
      </Content>

      <ActionBar onNext={handleNext} nextDisabled={nextDisabled}/>
    </div>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  errors: state.signup.errors,
  availDeliveryDays: state.signup.availDeliveryDays,
  loading: state.signup.loading
});

const mapDispatchToProps = dispatch => ({
  setData: data => dispatch({type: 'SET_DATA', payload: data}),
  setLoading: loading => dispatch({type: 'SET_LOADING', payload: loading}),
  setAvailDeliveryDays: availDays => dispatch({type: 'SET_AVAIL_DELIVERY_DAYS', payload: availDays})
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(DeliveryInfo)
);
